/* global $ */
import 'bootstrap-lombardia'

import 'bootstrap-lombardia/dist/css/bootstrap-lombardia.min.css'
import '../css/app.css'

let nomination = {}
const hideDelay = 0
const showDelay = 0

const thematicAreasDict = {
  ia_intelligent_systems: 'Intelligent systems to support the decisions in the Healthcare and Life Sciences sectors',
  ia_artificial_intelligence: 'Artificial Intelligence and Computational Models for Neuroscience',
  ia_intelligent_analysis: 'Intelligent analysis of biomedical data (radiomics, genomics, and proteomics) to support personalized medicine for rare diseases',
  ia_cyber_security: 'Cyber security models and systems to protect sensitive information for the health and life of citizens',
  ia_humanoid: 'Humanoid and assistive robotics to support fragile subjects',
  ia_innovative_systems: 'Innovative systems and technologies to improve the quality of life'
}

// File upload utils --------------------------------------------------------
window.formatBytes = function (bytes, decimals) {
  // credits: https://gist.github.com/zentala/1e6f72438796d74531803cc3833c039c
  if (bytes === 0) return '0 Bytes'
  var k = 1024
  var dm = decimals || 2
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  var i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

window.convertBase64 = function (file) {
  // credits : https://refine.dev/blog/how-to-base64-upload/
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(file)

    fileReader.onload = () => {
      resolve(fileReader.result)
    }

    fileReader.onerror = (error) => {
      reject(error)
    }
  })
}

// Recaptha Callback --------------------------------------------------------
window.recaptchaCallback = function (token) {
  if (token) {
    window.gRecaptchaResponseToken = token
    if ($('#policyCheckbox')[0].checked) {
      $('#submitButton').prop('disabled', false)
    }
  }
}
window.recaptchaExpireCallback = function () {
  $('#submitButton').prop('disabled', true)
  window.gRecaptchaResponseToken = null
}
// --------------------------------------------------------------------------

window.checkPolicy = async function (e) {
  e.preventDefault()
  const checkBox = $(this)[0]
  if (checkBox.checked) {
    if (window.gRecaptchaResponseToken) {
      $('#submitButton').prop('disabled', false)
    }
  } else {
    $('#submitButton').prop('disabled', true)
  }
}

window.downloadDeclaration = async function (e) {
  e.preventDefault()
  window.open('assets/doc/Absence of criminal convictions.pdf', '_blank')
}

$('#description-count-message').html('0 / ' + 1000)

$('#description').on('keyup', () => {
  let textLength = $('#description').val().length
  $('#description-count-message').html(textLength + ' / ' + 1000)
})

$('#motivation-count-message').html('0 / ' + 10000)

$('#motivation').on('keyup', () => {
  let textLength = $('#motivation').val().length
  $('#motivation-count-message').html(textLength + ' / ' + 10000)
})

window.goToSubmissionStep = async function (e) {
  // Check form validity
  let form = $('#candidature-form')[0]
  e.preventDefault()
  if (form.checkValidity() === false) {
    // Set form validation error from now on
    e.stopPropagation()
    form.classList.add('was-validated')
    window.selectError('thematicAreas')()
    return
  }

  $('#confirmButton').hide()
  $('#buttons-div').append(
    `<div id="spinner" class="spinner-border text-success" role="status">
      <span class="sr-only">Loading...</span>
    </div>`
  )

  const firstname = $('#candidature-form #firstname').val()
  const lastname = $('#candidature-form #lastname').val()
  const affiliation = $('#candidature-form #affiliation').val()
  const email = $('#candidature-form #email').val()
  const discoveryTitle = $('#candidature-form #discoveryTitle').val()
  let authorsRows = $('#candidature-form #authors-div .form-row')
  const authors = []
  for (let authorRow of authorsRows) {
    authors.push({
      firstname: $(authorRow).find('[id$=FirstName]').val(),
      lastname: $(authorRow).find('[id$=LastName]').val(),
      website: $(authorRow).find('[id$=Affiliation]').val()
    })
  }
  const description = $('#candidature-form #description').val()
  const motivation = $('#candidature-form #motivation').val()
  const thematicAreas = $('#candidature-form #thematicAreas').val()
  let papersRows = $('#candidature-form #papers-div .form-row')
  const papers = []
  for (let paperRow of papersRows) {
    papers.push({
      url: $(paperRow).find('[id^=paperLink]').val()
    })
  }
  const additionalInfo = $('#candidature-form #additionalInfo').val()
  const identityDocument = {
    content: await window.convertBase64(window.uploadedFiles['identity']),
    name: window.uploadedFiles['identity'].name
  }
  const declarationDocument = {
    content: await window.convertBase64(window.uploadedFiles['declaration']),
    name: window.uploadedFiles['declaration'].name
  }

  nomination = {
    firstname: firstname,
    lastname: lastname,
    email: email,
    affiliation: affiliation,
    identityDocument: identityDocument,
    declarationDocument: declarationDocument,
    title: discoveryTitle,
    authors: authors,
    thematicAreas: thematicAreas,
    description: description,
    motivation: motivation,
    papers: papers,
    additionalInfo: additionalInfo
  }

  const summary = buildNominationSummary(nomination)
  $('#candidature-form').hide(hideDelay)
  $('#summary-div').append(summary)
  $('#second-step').show(showDelay, () => {
    $('html, body').animate({
      scrollTop: $('#second-step').position().top - 100
    })
  })
}

window.backToForm = async function (e) {
  e.preventDefault()
  nomination = {}
  $('#second-step').hide(hideDelay)
  $('#notification-div').empty()
  $('#summary-div').empty()
  window.grecaptcha.reset()
  $('#submitButton').prop('disabled', true)
  $('#candidature-form').show(showDelay, () => {
    $('html, body').animate({
      scrollTop: $('#candidature-form').position().top - 30
    })
  })
  $('#spinner').remove()
  $('#confirmButton').show(showDelay)
}

window.submitNomination = async function (e) {
  e.preventDefault()
  nomination.gRecaptchaResponseToken = window.gRecaptchaResponseToken
  $('#goBackButton').hide(hideDelay)
  $('#submitButton').hide(hideDelay)
  $('#submit-button-div').append(
    `<div id="submit-spinner" class="spinner-border text-success" role="status">
      <span class="sr-only">Loading...</span>
    </div>`
  )
  const url = '/lr/content/create-candidature'
  $.post({
    url: url,
    data: JSON.stringify(nomination),
    dataType: 'json',
    processData: false,
    contentType: 'application/json; charset=utf-8'
  }).done(function (result) {
    $('#submit-spinner').remove()
    if ('error' in result) {
      window.grecaptcha.reset()
    } else {
      $('#submit-form').remove()
    }
    window.showNotification(result)
  }).fail(function (result) {
    window.grecaptcha.reset()
    $('#submit-spinner').remove()
    $('#submitButton').show(showDelay)
    $('#submitButton').prop('disabled', true)
    $('#goBackButton').show(showDelay)
    window.showNotification(result)
  })
}

window.changedFile = function (prefix) {
  return function (event) {
    window.uploadedFiles[prefix] = event.target.files[0]
    const filename = window.uploadedFiles[prefix].name
    const fileSize = window.uploadedFiles[prefix].size

    const uploadfileListId = '#' + prefix + 'UploadFileList'
    const removeFileId = '#' + prefix + 'RemoveFile'

    $(uploadfileListId).empty()
    const li = `
          <li class="upload-file success">
              <svg class="icon icon-sm" aria-hidden="true">
                  <use xlink:href="bootstrap-lombardia/dist/svg/sprite.svg#it-file"></use>
              </svg>
              <p>
                  <span class="sr-only">Uploaded file name:</span>` + filename + `
                  <span class="upload-file-weight">` + window.formatBytes(fileSize) + `</span>
              </p>
              <button id="` + prefix + `RemoveFile">
                  <span class="sr-only">Upload complete</span>
                  <svg class="icon" aria-hidden="true">
                      <use xlink:href="bootstrap-lombardia/dist/svg/sprite.svg#it-close">
                      </use>
                  </svg>
              </button>
          </li>`
    $(uploadfileListId).append(li)
    $(removeFileId).on('click', function (event) {
      $('#candidature-form #' + prefix + 'Document').val('')
      $(uploadfileListId).empty()
      window.uploadedFiles[prefix] = undefined
      event.preventDefault()
      event.stopPropagation()
    })
  }
}

window.addAuthor = function (event) {
  event?.preventDefault()
  const childrenCount = $('#authors-div .form-row').length
  if (childrenCount === 3) {
    return
  }
  /* In this implementation index is only used to avoid conflict in displaying form-rows of authors */
  /* When data are submitted it may be useful to create an array of authors with same fields name */
  const index = window.authorIndex
  const authorRow = `
        <div id="author` + index + `" class="form-row">
            <div class="col-12">
                <div class="row">
                    <div class="form-group col-6 col-md-3 ">
                        <input type="text" class="form-control" id="author` + index + `FirstName" name="author` + index + `FirstName" required>
                        <label for="author` + index + `FirstName">First Name <span class="text-danger">*</span></label>
                        <div class="invalid-feedback">Missing value</div>
                    </div>
                    <div class="form-group col-6 col-md-3">
                      <input type="text" class="form-control" id="author` + index + `LastName" name="author` + index + `LastName" required>
                      <label for="author` + index + `LastName">Last Name <span class="text-danger">*</span></label>
                      <div class="invalid-feedback">Missing value</div>
                    </div>
                    <div class="form-group col-6 col-sm-8 col-md-3">
                        <input type="text" class="form-control" id="author` + index + `Affiliation" name="author` + index + `Affiliation" required>
                        <label for="author` + index + `Affiliation">Affiliation/WebSite <span class="text-danger">*</span></label>
                        <div class="invalid-feedback">Missing value</div>
                    </div>
                    <div class="col-6 col-sm-4 col-md-3">
                        <div class="row">
                            <div class="col-6 d-flex justify-content-end">
                                ` + (index === 0 ? `` : `
                                <button class="button btn-danger remove-button" 
                                        data-toggle="tooltip" data-placement="top" title="Remove this author"       
                                        onclick="removeAuthor(event, ` + index + `)">
                                    <svg class="icon icon-white">
                                        <use xlink:href="bootstrap-lombardia/dist/svg/sprite.svg#it-minus">
                                        </use>
                                    </svg>
                                </button>
                                `) + `
                            </div>
                            <div class="col-6 d-flex justify-content-start">
                                <button class="button btn-primary add-button" 
                                        data-toggle="tooltip" data-placement="top" title="Add another author" 
                                        onclick="addAuthor(event)">
                                    <svg class="icon icon-white icon-success">
                                        <use xlink:href="bootstrap-lombardia/dist/svg/sprite.svg#it-plus">
                                        </use>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
  $('#authors-div').append(authorRow)
  window.authorButtonsManagement()

  window.authorIndex++
}

window.authorButtonsManagement = function () {
  // Gestiamo abilitazione tasto aggiunta autori
  const addButtons = $('#authors-div .add-button')
  if (addButtons.length === 3) {
    addButtons.prop('disabled', true)
  } else {
    addButtons.prop('disabled', false)
  }
}

window.removeAuthor = function (event, index) {
  event.preventDefault()
  const childrenCount = $('#authors-div .form-row').length
  if (childrenCount === 1) {
    return
  }
  $('#authors-div #author' + index).remove()
  window.authorButtonsManagement()
}

window.addPaper = function (event) {
  event?.preventDefault()
  const childrenCount = $('#papers-div .form-row').length
  if (childrenCount === 5) {
    return
  }
  const index = window.paperIndex
  const paperRow = `
        <div id="paper` + index + `" class="form-row">
            <div class="form-group col-6 col-sm-8 col-md-10">
                <input type="url" class="form-control" id="paperLink` + index + `" name="paperLink` + index + `" required>
                <label for="paperLink` + index + `">Bibliographic URL <span class="text-danger">*</span></label>
                <div class="invalid-feedback">Missing or invalid value</div>
            </div>
            <div class="col-6 col-sm-4 col-md-2">
                <div class="row">
                    <div class="col-6 d-flex justify-content-end">
                        ` + (index === 0 ? `` : `
                        <button class="button btn-danger remove-button" 
                                data-toggle="tooltip" data-placement="top" title="Remove this url"       
                                onclick="removePaper(event, ` + index + `)">
                            <svg class="icon icon-white">
                                <use xlink:href="bootstrap-lombardia/dist/svg/sprite.svg#it-minus"></use>
                            </svg>
                        </button>
                        `) + `
                    </div>
                    <div class="col-6 d-flex justify-content-start">
                        <button class="button btn-primary add-button" 
                                data-toggle="tooltip" data-placement="top" title="Add another Bibliographic URL" 
                                onclick="addPaper(event)">
                            <svg class="icon icon-white icon-success">
                                <use xlink:href="bootstrap-lombardia/dist/svg/sprite.svg#it-plus"></use>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        `
  $('#papers-div').append(paperRow)
  window.paperIndex++
  window.urlButtonsManagement()
}

window.urlButtonsManagement = function () {
  // Gestiamo abilitazione tasto aggiunta url
  const addButtons = $('#papers-div .add-button')
  if (addButtons.length === 5) {
    addButtons.prop('disabled', true)
  } else {
    addButtons.prop('disabled', false)
  }
}

window.removePaper = function (event, index) {
  event.preventDefault()
  const childrenCount = $('#papers-div .form-row').length
  if (childrenCount === 1) {
    return
  }
  $('#papers-div #paper' + index).remove()
  window.urlButtonsManagement()
}

function camelCaseToTitle (str) {
  str = str.replace(/([A-Z])/g, ' $1')
  return str.charAt(0).toUpperCase() + str.slice(1)
}

function buildList (list, mapFunction) {
  return '<ul><li>' + list.map(mapFunction).join('</li><li>') + '</li></ul>'
}

function getValueToPrintInSummaryMessage (key, paramValue) {
  switch (key) {
    case 'identityDocument':
    case 'declarationDocument':
      return paramValue.name
    case 'authors':
      return buildList(paramValue, (author) => author.firstname + ' ' + author.lastname)
    case 'papers':
      return buildList(paramValue, (paper) => paper.url)
    case 'thematicAreas':
      return buildList(paramValue, (thematicArea) => thematicAreasDict[thematicArea])
    default:
      return paramValue
  }
}

function buildNominationSummary () {
  let summary = 'Please review and confirm your nomination.'
  summary += '<br><br><strong>Nomination data:</strong><br><ul>'
  for (let key of Object.keys(nomination)) {
    if (key === 'gRecaptchaResponseToken') {
      continue
    }
    const valueToPrint = getValueToPrintInSummaryMessage(key, nomination[key])
    let keyToPrint = camelCaseToTitle(key)
    summary += '<li><strong>' + keyToPrint + ':</strong> ' + valueToPrint + '</li>'
  }
  summary += '</ul>'
  const summaryCallout = `
  <div class="row mb-5">
    <div class="col-0 col-sm-1"></div>
    <div class="col-12 col-sm-10">
      <div class="callout mw-100 success">
        <div class="callout-title px-3">
          <svg class="icon"><use xlink:href="bootstrap-lombardia/dist/svg/sprite.svg#it-check-circle"></use></svg>Nomination Summary</div>
            ` + summary + `
        </div>
      </div>
    </div>
  </div>`
  return summaryCallout
}

window.showNotification = function (res) {
  $('#notification-div').empty()
  const result = res.responseJSON?.result || res.result
  let message = result?.message || 'Impossible to communicate with the server'
  const success = message === 'OK'
  message = success ? 'Your nomination has been submitted.<br>In a few moments you will receive an email with the summary of your nomination.' : message
  const title = success ? 'Thank you for your contribution' : 'Submission Failed'
  const calloutClass = success ? 'success' : 'danger'
  const icon = success ? 'it-check-circle' : 'it-close-circle'
  const messageHtml = `
  <div class="row mb-5">
    <div class="col-0 col-sm-1 col-md-2 col-lg-3"></div>
    <div class="col-12 col-sm-10 col-md-8 col-lg-6">
      <div class="callout mw-100 ` + calloutClass + `">
        <div class="callout-title px-3">
          <svg class="icon"><use xlink:href="bootstrap-lombardia/dist/svg/sprite.svg#` + icon + `"></use></svg>` + title + `</div>
            ` + message + `
        </div>
      </div>
    </div>
  </div>`
  $('#notification-div').append(messageHtml)
  $('html, body').animate({
    scrollTop: $('#notification-div').position().top - 100
  })
}

window.selectError = function (identifier) {
  return function () {
    let ta = $('#' + identifier)[0]
    let errMsg = $('#' + identifier + 'Error')[0]
    if (ta.matches(':invalid')) {
      errMsg.classList.add('d-block')
    } else {
      errMsg.classList.remove('d-block')
    }
  }
}

// Questa parte serve per mostrare il risultato del tentativo di conferma di una candidatura, gestendo il redirect dal backend
// Da riattivare in caso si decidesse di ripristinare il meccanismo di conferma che è stato tolto
/* $(function () {
  let searchParams = new URLSearchParams(window.location.search)
  if (!searchParams.has('confirm')) {
    return
  }
  const confirm = searchParams.get('confirm') === 'true'
  let hideForm = confirm
  if (searchParams.has('code')) {
    hideForm = searchParams.get('code') === '1'
  }
  if (hideForm) {
    $('#page-content').remove()
  }
  let message = ''
  if (searchParams.has('message')) {
    message = '<p>' + searchParams.get('message') + '</p>'
  }
  const title = confirm ? 'Nomination Confirmed' : 'Confirm Failed'
  const calloutClass = confirm ? 'success' : 'danger'
  const icon = confirm ? 'it-check-circle' : 'it-close-circle'
  const messageHtml = `
  <div class="row mt-5 mb-5">
    <div class="col-3"></div>
    <div class="col-6">
      <div class="callout mw-100 ` + calloutClass + `">
        <div class="callout-title">
          <svg class="icon"><use xlink:href="bootstrap-lombardia/dist/svg/sprite.svg#` + icon + `"></use></svg>` + title + `</div>
            ` + message + `
        </div>
      </div>
    </div>
  </div>`
  $('#confirm-content').append(messageHtml)
}) */

$(function () {
  let form = $('#candidature-form')
  if (form) {
    form.trigger('reset')
  }
  window.authorIndex = 0
  window.paperIndex = 0
  window.uploadedFiles = {
    'identity': undefined,
    'declaration': undefined
  }
  window.gRecaptchaResponseToken = undefined

  // File upload
  $('#identityDocument').on('change', window.changedFile('identity'))
  $('#declarationDocument').on('change', window.changedFile('declaration'))

  // Manage select errors
  $('#thematicAreas').on('change', window.selectError('thematicAreas'))

  // Submit
  $('#candidature-form').on('submit', window.goToSubmissionStep)
  $('#submit-form').on('submit', window.submitNomination)

  // Policy checkbox
  $('#policyCheckbox').on('change', window.checkPolicy)

  window.addAuthor(null)
  window.addPaper(null)

  // Show page after initialization
  $('body').prop('style', '')
})
